// extracted by mini-css-extract-plugin
export default {"square":"square_square__bZaNP","activeSquare":"square_activeSquare__8DKIF"};